import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from 'react-router-dom';  // Use BrowserRouter
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./styles/theme";
import App from './App';

// MSAL imports
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  // Get the container to render the app
  const container = document.getElementById("root");
  
  // Check if the container element is found
  if (!container) {
    console.error('Root element not found!');
    return;
  }

  // Create the root and render the app
  const root = ReactDOM.createRoot(container);

  // Render the app with MSAL provider
  root.render(
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter> {/* Use BrowserRouter for clean URLs */}
          <App pca={msalInstance} />
        </BrowserRouter>
      </MsalProvider>
    </ThemeProvider>
  );
}).catch(error => {
  console.error("MSAL initialization failed:", error);
});
